import { CheckBox, Icon } from "web/components"

import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"

export const sectionHeaderDefaultClasses =
  "flex bg-neutral-9 text-sm overflow-hidden"

export default function SectionHeader({
  title,
  subject,
  selectionEnabled,
  icon,
  expanded,
  onToggle,
  onSelectionChanged,
}) {
  function handleSelectionChanged() {
    onSelectionChanged({ ...subject, selected: !subject.selected })
  }

  return (
    <div className={sectionHeaderDefaultClasses} onClick={onToggle}>
      <div className="h-inherit flex items-center px-2 ring-0">
        <Icon outline className="my-auto size-5" name={icon} />
      </div>
      <div className="flex flex-auto">
        <div className="flex-grow overflow-hidden p-2">
          <div className="truncate">{title || subject.name}</div>
        </div>
        <div className="flex items-center justify-center px-2">
          <span className="size-5 text-neutral-6">
            {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </span>
        </div>
      </div>
      {selectionEnabled && (
        <div className="h-inherit my-auto px-2">
          <CheckBox
            value={{ value: subject.selected || false }}
            onChange={handleSelectionChanged}
            showValueLabel={false}
          />
        </div>
      )}
    </div>
  )
}
